// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/src--flow.json";
import part1 from "./en/src--hooks--chooseCompensationMethod.json";
import part2 from "./en/src--hooks--shared-hooks--use-common-choose-compensation.json";
import part3 from "./en/src--hooks--use-flow-ai-return-reasons.json";
import part4 from "./en/src--hooks--use-flow-input.json";
import part5 from "./en/src--hooks--use-flow-reject.json";
import part6 from "./en/src--hooks--use-flow-return.json";
import part7 from "./en/src--hooks--use-recommended-product-exchange.json";
import part8 from "./en/src--hooks--use-variant-exchange.json";
import part9 from "./en/src--hooks--use-variant-picker.json";
import part10 from "./en/src--hooks--useAddress.json";
import part11 from "./en/src--hooks--useCarrierOptions.json";
import part12 from "./en/src--hooks--useCart.json";
import part13 from "./en/src--hooks--useEditAddress.json";
import part14 from "./en/src--hooks--useFlow.json";
import part15 from "./en/src--hooks--useItemDetails.json";
import part16 from "./en/src--hooks--useMerchantFlow.json";
import part17 from "./en/src--hooks--usePackagePickup.json";
import part18 from "./en/src--hooks--usePackagePickupUpsell.json";
import part19 from "./en/src--hooks--useProvisionSelection.json";
import part20 from "./en/src--hooks--useRefundDestination.json";
import part21 from "./en/src--hooks--useReturnConfirmation.json";
import part22 from "./en/src--hooks--useReview.json";
import part23 from "./en/src--hooks--useSelectItems.json";
import part24 from "./en/src--hooks--useShipmentMethod.json";
import part25 from "./en/src--hooks--useShopNow.json";
import part26 from "./en/src--hooks--useShopOnSite.json";
import part27 from "./en/src--utils.json";
import part28 from "./en/src.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
  part7,
  part8,
  part9,
  part10,
  part11,
  part12,
  part13,
  part14,
  part15,
  part16,
  part17,
  part18,
  part19,
  part20,
  part21,
  part22,
  part23,
  part24,
  part25,
  part26,
  part27,
  part28,
);
